export default __webpack_public_path__ + "static/media/cloud_dreams.854bdb4b.png";